
import request from '../request'

export function uploadFile(data) {
    return request({
        url: '/Api/Me/upload',
        data,
        method: 'POST'
    })
}